import { useProfile } from "@brg/auth"
import { ExternalLink } from "@brg/ui"
import { useTranslation } from "react-i18next"
import styled, { css } from "styled-components"


const MainContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    margin-top: 48px;
    padding: 40px 80px;
    flex-direction: column;
    align-items: center;

    div {
        display: flex;
        width: 100%;
        justify-content: center;
    }
`

const MainText = styled.div`
    display: flex;
    color: #151514;
    text-align: center;
    font-family: Inter;
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: 40px;
    letter-spacing: -0.6px;
`

const CreateText = styled.div`
    margin-top: 16px;
    color: #151514;
    text-align: center;
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.34px;
`

const GalleryLinkButton = styled.div<{isBlank?: boolean}>`
    margin-top: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 13px 48px;
    border-radius: 3px;
    cursor: pointer;
    border: 1px solid #151514;
    ${({isBlank}) => 
    (
        !isBlank && css`
            border: none;
            background: #151514;
            color: #fff;
        `
    )
    }
`

const ButtonWrapper = styled.div`
    gap: 24px;
`

interface UsedInProjectModalProps {
    onSubmit: () => void;
    onCancel: () => void;
    text?: string;
}

const UsedInProjectModal = (props: UsedInProjectModalProps) => {

    const {onSubmit, onCancel, text} = props

    const {t} = useTranslation()
    const {accountId: id} = useProfile() || {accountId: ''}

    return <MainContainer>
        <MainText>
            {text || ''}
        </MainText>
        <ButtonWrapper>
            <GalleryLinkButton onClick={() => onSubmit && onSubmit()}>
                {t('not_saved_modal.proceed')}
            </GalleryLinkButton>
            <GalleryLinkButton onClick={() => onCancel && onCancel()} isBlank>
                {t('not_saved_modal.exit')}
            </GalleryLinkButton> 
        </ButtonWrapper>                
    </MainContainer>
}

export default UsedInProjectModalimport { useProfile } from "@brg/auth"
import { ExternalLink } from "@brg/ui"
import { useTranslation } from "react-i18next"
import styled, { css } from "styled-components"


const MainContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    margin-top: 48px;
    padding: 40px 80px;
    flex-direction: column;
    align-items: center;

    div {
        display: flex;
        width: 100%;
        justify-content: center;
    }
`

const MainText = styled.div`
    display: flex;
    color: #151514;
    text-align: center;
    font-family: Inter;
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: 40px;
    letter-spacing: -0.6px;
`

const CreateText = styled.div`
    margin-top: 16px;
    color: #151514;
    text-align: center;
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.34px;
`

const GalleryLinkButton = styled.div<{isBlank?: boolean}>`
    margin-top: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 13px 48px;
    border-radius: 3px;
    cursor: pointer;
    border: 1px solid #151514;
    ${({isBlank}) => 
    (
        !isBlank && css`
            border: none;
            background: #151514;
            color: #fff;
        `
    )
    }
`

const ButtonWrapper = styled.div`
    gap: 24px;
`

interface UsedInProjectModalProps {
    onSubmit: () => void;
    onCancel: () => void;
    text?: string;
}

const UsedInProjectModal = (props: UsedInProjectModalProps) => {

    const {onSubmit, onCancel, text} = props

    const {t} = useTranslation()
    const {accountId: id} = useProfile() || {accountId: ''}

    return <MainContainer>
        <MainText>
            {text || ''}
        </MainText>
        <ButtonWrapper>
            <GalleryLinkButton onClick={() => onSubmit && onSubmit()}>
                {t('not_saved_modal.proceed')}
            </GalleryLinkButton>
            <GalleryLinkButton onClick={() => onCancel && onCancel()} isBlank>
                {t('not_saved_modal.exit')}
            </GalleryLinkButton> 
        </ButtonWrapper>                
    </MainContainer>
}

export default UsedInProjectModal